import React from 'react';
import { Title } from '../components';
import Service from './Service';
import { services } from '../data';

const Services = () => {
  return (
    <section className="section " id="services">
      <Title title="our services" />
      <div className="section-center bg-amber-50 rounded-3xl">
        <div className="flex flex-wrap">
          {services.map(ser => (
            <Service key={ser.id} {...ser} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
